'use es6';

import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ContentManagement from 'ContentEditorUI/components/contentManagement/ContentManagement';
import StandardSidebarContainer from 'ContentEditorUI/components/StandardSidebarContainer';
import LegacySidebarContentContainer from 'ContentEditorUI/containers/SidebarContainer';
import LegacySidebarPanelContainer from './SidebarPanelContainer';
import PatagoniaAddPanel from 'ContentEditorUI/components/sidebar/PatagoniaAddPanel';
import PatagoniaSidebarContent from '../components/sidebar/PatagoniaSidebarContent';
import PatagoniaXrayPanel from 'ContentEditorUI/components/xray/recommendationPanels/PatagoniaXrayPanel';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getDefaultAddPanelContentWidth } from 'ContentEditorUI/js/utils/sidebarUtil';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { getSeoSectionConfigForBlog } from 'xray-recommendation-lib/seo/configs/seoSectionConfig';
import { AddIcon, SiteTreeIcon, GaugeIcon, FileIcon, EditIcon } from 'foundations-assets';
import { SIDEBAR_PANELS, LAYERS_SIDEBAR_WIDTH, EDIT_MODULE_SIDEBAR_WIDTH, OPTIMIZER_SIDEBAR_WIDTH, PAGE_MANAGEMENT_SIDEBAR_WIDTH, PUSHY, FLOATY } from 'ContentEditorUI/lib/sidebar/constants';
import { getAuth } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getActiveSidebarPanel, getEditSidebarActiveTab, getSelectedField } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getSelectedModuleName } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getCurrentTab } from 'ContentEditorUI/redux/selectors/universalNavSelectors';
import { setXrayInpageGathererKeys } from 'ContentEditorUI/redux/actions/xrayActions';
import { useEffect, useMemo } from 'react';
import { xrayEditorApi } from '../redux/actions/xrayActions';
import { jsx as _jsx } from "react/jsx-runtime";
const SidebarPanelContainer = () => {
  const activePanel = useSelector(getActiveSidebarPanel);
  const selectedModuleName = useSelector(getSelectedModuleName);
  const editSidebarActiveTab = useSelector(getEditSidebarActiveTab);
  const selectedField = useSelector(getSelectedField);
  return /*#__PURE__*/_jsx(LegacySidebarPanelContainer, {
    panelName: activePanel,
    selectedModuleName: selectedModuleName,
    editSidebarActiveTab: editSidebarActiveTab,
    selectedField: selectedField
  });
};
const SidebarContentContainer = () => {
  const currentTab = useSelector(getCurrentTab);
  return /*#__PURE__*/_jsx(LegacySidebarContentContainer, {
    currentTab: currentTab,
    showDeviceToggle: false,
    children: /*#__PURE__*/_jsx(SidebarPanelContainer, {})
  });
};
const SidebarContainer = () => {
  const dispatch = useDispatch();
  const categorizedSearchQuery = useSelector(getSidebarSearchQuery);
  const auth = useSelector(getAuth);
  const xrayConfigFromEditor = useMemo(() => getSeoSectionConfigForBlog(xrayEditorApi, auth), [auth]);
  useEffect(() => {
    dispatch(setXrayInpageGathererKeys(xrayConfigFromEditor));
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const sidebarOptions = useMemo(() => {
    const tooltipLabel = 'patagonia.sidebar.tooltipLabel';
    return [{
      type: 'panel',
      iconName: 'add',
      iconNode: AddIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.add`
      }),
      panelName: SIDEBAR_PANELS.addWidget,
      content: /*#__PURE__*/_jsx(PatagoniaAddPanel, {}),
      contentWidth: getDefaultAddPanelContentWidth(PATAGONIA_ADD_PANEL_CATEGORIES.MODULES, categorizedSearchQuery),
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'siteTree',
      iconNode: SiteTreeIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.pageContents,
      content: /*#__PURE__*/_jsx(PatagoniaSidebarContent, {}),
      contentWidth: LAYERS_SIDEBAR_WIDTH,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'separator'
    }, {
      type: 'panel',
      iconName: 'gauge',
      iconNode: GaugeIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.optimizer`
      }),
      panelName: SIDEBAR_PANELS.optimizer,
      content: /*#__PURE__*/_jsx(PatagoniaXrayPanel, {
        config: xrayConfigFromEditor
      }),
      contentWidth: OPTIMIZER_SIDEBAR_WIDTH,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'separator'
    }, {
      type: 'panel',
      iconName: 'file',
      iconNode: FileIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageManagement`
      }),
      panelName: SIDEBAR_PANELS.pageManagement,
      content: /*#__PURE__*/_jsx(ContentManagement, {}),
      contentWidth: PAGE_MANAGEMENT_SIDEBAR_WIDTH,
      hideItem: false,
      panelDisplay: {
        type: FLOATY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'edit',
      iconNode: EditIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.edit,
      content: /*#__PURE__*/_jsx(SidebarContentContainer, {}),
      contentWidth: EDIT_MODULE_SIDEBAR_WIDTH,
      hideItem: true,
      panelDisplay: {
        type: PUSHY,
        showScroll: true
      }
    }];
  }, [categorizedSearchQuery, xrayConfigFromEditor]);
  return /*#__PURE__*/_jsx(StandardSidebarContainer, {
    sidebarOptions: sidebarOptions
  });
};
export default SidebarContainer;